import type { FC } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import type { AdsHistoryGroupedEntry } from './AdsHistoryGroupedView.mockData';

const AdsHistoryPackInfo: FC<{ entry: AdsHistoryGroupedEntry }> = ({ entry }) => {
  const { email, created_at, ad_account, ad_set, message, status } = entry;
  const date = created_at ? new Date(created_at).toISOString().slice(0, 10) : '';

  return (
    <Box
      sx={(t) => ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: 3,
        px: 2,
        py: 1.5,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: status ? 'transparent' : t.palette.error.light + '10',
      })}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary">Created by</Typography>
        <Typography variant="body2">{email}</Typography>
        <Typography variant="caption" color="text.secondary">{date}</Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary">Ad account</Typography>
        <Typography variant="body2">{ad_account.name}</Typography>
        <Typography variant="caption" color="text.secondary">{ad_account.id}</Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, maxWidth: 360 }}>
        <Typography variant="caption" color="text.secondary">Adset</Typography>
        <Tooltip title={ad_set.name} placement="bottom">
          <Typography variant="body2" noWrap>{ad_set.name}</Typography>
        </Tooltip>
        <Typography variant="caption" color="text.secondary">{ad_set.id}</Typography>
      </Box>
      {!status && message && (
        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
          <Typography variant="caption" color="error.main">Error message</Typography>
          <Typography variant="body2" color="error.main">{message}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default AdsHistoryPackInfo;
